module.exports = __webpack_public_path__ + "img/browser.113f0e3a.svg";